import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_CHANNELS_SELECT_EMAIL } from 'ducks/drawers/types'

const AddNewMailboxLink = ({ showMessage, children }) => {
  const { openDrawer: openAddDrawer } = useDrawer({
    type: DRAWER_TYPE_CHANNELS_SELECT_EMAIL,
    lazyLoad: true,
  })

  const onOpen = useCallback(
    () => {
      openAddDrawer('new')
    },
    [openAddDrawer]
  )

  return (
    <>
      {showMessage && (
        <>
          <div className="title">Add your support email</div>
          <div>
            Once you&apos;ve connected your support inbox, all your messages
            will appear.
          </div>
          <br />
        </>
      )}
      <Button size="small" onClick={onOpen}>
        {children || 'Add a Mailbox'}
      </Button>
    </>
  )
}

AddNewMailboxLink.propTypes = {
  showMessage: PropTypes.isRequired,
}

AddNewMailboxLink.defaultProps = {
  showMessage: false,
}

export default AddNewMailboxLink
